exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-a6651318] .pullup-wrapper{color:gray;}\nbody[data-v-a6651318] {\n       background: #fff\n}\n", ""]);

// exports
